import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import useHasOpenDataPartnerAccess from '@/composables/useHasOpenDataPartnerAccess';
import { BILLING_VERSION } from '@/constants/billing';
import { OVER_SEAT_QUOTA_ALLOWED } from '@/constants/feature_flags';
import { useBillingStore, useFeatureFlagStore } from '@/stores';

export default function useHasFeature() {
  const billingStore = useBillingStore();
  const featureFlagStore = useFeatureFlagStore();
  const hasOpenDataPartnerAccess = useHasOpenDataPartnerAccess();

  const {
    isSupernodeOrEnterpriseTier,
    isConnectorTier,
    offlinePartnersQuota,
    offlinePartnerOrgsUsed,
    openDataPartnersQuota,
    openDataPartnerOrgsUsed,
    billingVersion,
  } = storeToRefs(billingStore);

  const canGoOverSeatQuota = computed(() => {
    return (
      isSupernodeOrEnterpriseTier.value &&
      featureFlagStore.hasFeatureFlag(OVER_SEAT_QUOTA_ALLOWED)
    );
  });

  const hasPotentialRevenue = computed(
    () => isSupernodeOrEnterpriseTier.value || isConnectorTier.value,
  );

  const canAddOfflinePartner = computed(() => {
    return offlinePartnerOrgsUsed.value < offlinePartnersQuota.value;
  });

  const canAddOpenDataPartner = computed(() => {
    if (hasOpenDataPartnerAccess.value) {
      return openDataPartnerOrgsUsed.value < openDataPartnersQuota.value;
    }
    return offlinePartnerOrgsUsed.value < offlinePartnersQuota.value;
  });

  const onLatestBilling = computed(
    () => BILLING_VERSION === billingVersion.value,
  );

  return {
    onLatestBilling,
    hasPotentialRevenue,
    canGoOverSeatQuota,
    canAddOfflinePartner,
    canAddOpenDataPartner,
  };
}
